function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-log-out",
  "data-name": "Icon feather-log-out",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_250",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 250",
  d: "M4.5,24.988H9.053a2.276,2.276,0,0,0,2.276-2.276V6.776A2.276,2.276,0,0,0,9.053,4.5H4.5",
  transform: "translate(9.159 -4.5)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_251",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 251",
  d: "M29.691,21.882,24,16.191,29.691,10.5",
  transform: "translate(-24 -5.947)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_252",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 252",
  d: "M13.5,18H27.159",
  transform: "translate(-13.5 -7.756)",
  fill: "none",
  stroke: "#66c3d0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.488,
    height: 21.488,
    viewBox: "0 0 21.488 21.488",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.f11ddaf3.svg";
export { ForwardRef as ReactComponent };